module.exports = __webpack_public_path__ + "img/galeria-especie-exotica-7.2454a6f4.jpg";